import { render } from "./backToTop.vue?vue&type=template&id=6a9caf92"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__